import { LINK_CAPABILITY_BYTES, LINK_IV_BYTES, LINK_KEY_BYTES } from "./constants";
import { encodeBase64Url } from "./base64url";

export interface LinkCapabilities {
  accessToken: string;
  revokeToken: string;
}

function randomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return bytes;
}

export function generateLinkCapabilities(): LinkCapabilities {
  return {
    accessToken: encodeBase64Url(randomBytes(LINK_CAPABILITY_BYTES)),
    revokeToken: encodeBase64Url(randomBytes(LINK_CAPABILITY_BYTES)),
  };
}

export function generateEncryptionKeyBytes(): Uint8Array {
  return randomBytes(LINK_KEY_BYTES);
}

export function generateEncryptionIv(): Uint8Array {
  return randomBytes(LINK_IV_BYTES);
}
